import { useState } from "react";
import { toast } from "react-hot-toast";

export const useFilePreview = () => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getFileExtension = (filename) => {
    return filename?.split(".").pop()?.toLowerCase() || "";
  };

  const generatePreviewUrl = (fileUrl, fileName) => {
    const extension = getFileExtension(fileName);

    if (extension === "pdf") {
      return `https://docs.google.com/gview?url=${encodeURIComponent(
        fileUrl
      )}&embedded=true#page=1&zoom=100`;
    } else if (["doc", "docx"].includes(extension)) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        fileUrl
      )}`;
    } else {
      return `https://docs.google.com/gview?url=${encodeURIComponent(
        fileUrl
      )}&embedded=true`;
    }
  };

  const openPreview = async (fileUrl, fileName) => {
    if (!fileUrl) {
      toast.error("Файл URL табылмады");
      return;
    }

    setIsLoading(true);

    try {
      const viewerUrl = generatePreviewUrl(fileUrl, fileName);
      setPreviewUrl(viewerUrl);
      setIsPreviewOpen(true);
    } catch (error) {
      console.error("Preview error:", error);
      toast.error("Файлды көрсету мүмкін болмады");
    } finally {
      setIsLoading(false);
    }
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
    setPreviewUrl("");
  };

  return {
    isPreviewOpen,
    previewUrl,
    isLoading,
    openPreview,
    closePreview,
  };
};
